



































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditEtikaBatukService from "@/services/AuditEtikaBatukService";
import {
  KRITERIA_ETIKA_BATUK,
  KATEGORI_OBSERVEE_OPTIONS
} from "@/constants/kriteriaEtikaBatuk";

@Component
export default class AuditEtikaBatukDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;
  kategoriOptions = KATEGORI_OBSERVEE_OPTIONS;

  signDialog = false;
  signStage: "auditor" | "ketua_ppi" | "kaunit" | "direktur" | null = null;
  signPassword = "";
  signing = false;

  temuanDialog = false;
  temuanForm: any = {};
  savingTemuan = false;

  kesimpulanModel = "";

  kriteriaSelectOptions = KRITERIA_ETIKA_BATUK.map(k => ({
    text: `#${k.no} — ${k.kriteria}`,
    value: k.no
  }));

  statusTemuanOptions = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  kriteriaHeaders = [
    { text: "#", value: "no", width: 40 },
    { text: "Kriteria", value: "kriteria" },
    { text: "Penilaian", value: "penilaian", width: 80 },
    { text: "Kepatuhan", value: "kepatuhan", width: 110 },
    { text: "Rek", value: "rekomendasi", width: 50 },
    { text: "Catatan", value: "catatan" }
  ];

  temuanHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Kriteria", value: "kriteria_no", width: 70 },
    { text: "Temuan", value: "uraian" },
    { text: "RTL", value: "rencana_tindak_lanjut" },
    { text: "PIC", value: "pic_nama" },
    { text: "Target", value: "target_waktu" },
    { text: "Status", value: "status_chip" },
    { text: "", value: "actions", sortable: false, width: 80 }
  ];

  signStages = [
    {
      key: "auditor",
      label: "Auditor / Tim PPI",
      sub: "Dibuat Oleh",
      timestampField: "signed_auditor_at",
      waitFor: "—",
      getName: (s: any) => s.auditor_nama || (s.auditor && s.auditor.identitas && s.auditor.identitas.nama),
      canSign: (s: any) => !s.signed_auditor_at
    },
    {
      key: "ketua_ppi",
      label: "Ketua Komite PPI",
      sub: "Diperiksa Oleh",
      timestampField: "signed_ketua_ppi_at",
      waitFor: "Auditor",
      getName: (s: any) => s.signed_ketua_ppi && s.signed_ketua_ppi.identitas && s.signed_ketua_ppi.identitas.nama,
      canSign: (s: any) => !!s.signed_auditor_at && !s.signed_ketua_ppi_at
    },
    {
      key: "kaunit",
      label: "Ka. Unit / Kepala Ruangan",
      sub: "Disetujui Oleh",
      timestampField: "signed_kaunit_at",
      waitFor: "Ketua PPI",
      getName: (s: any) => s.signed_kaunit && s.signed_kaunit.identitas && s.signed_kaunit.identitas.nama,
      canSign: (s: any) => !!s.signed_ketua_ppi_at && !s.signed_kaunit_at
    },
    {
      key: "direktur",
      label: "Direktur / Pimpinan",
      sub: "Mengetahui",
      timestampField: "signed_direktur_at",
      waitFor: "Ka. Unit",
      getName: (s: any) => s.signed_direktur && s.signed_direktur.identitas && s.signed_direktur.identitas.nama,
      canSign: (s: any) => !!s.signed_kaunit_at && !s.signed_direktur_at
    }
  ];

  get signStageLabel() {
    const s = this.signStages.find(x => x.key === this.signStage);
    return s ? `${s.label} — ${s.sub}` : "";
  }

  get responsesTable() {
    const map: any = {};
    (this.session?.responses || []).forEach((r: any) => (map[r.kriteria_no] = r));
    return KRITERIA_ETIKA_BATUK.map(k => {
      const r = map[k.no] || {};
      return {
        no: k.no,
        kriteria: k.kriteria,
        penilaian: r.penilaian ?? null,
        rekomendasi: !!r.rekomendasi,
        catatan: r.catatan || ""
      };
    });
  }

  async mounted() {
    await this.loadSession();
  }

  async loadSession() {
    const res = await AuditEtikaBatukService.find(this.sessionId);
    this.session = res.data.data;
    this.kesimpulanModel = this.session.kesimpulan_umum || "";
  }

  kategoriLabel(k: string): string {
    return this.kategoriOptions.find(o => o.value === k)?.text || k || "—";
  }

  async saveKesimpulan() {
    if (this.session.is_locked) return;
    if ((this.kesimpulanModel || "") === (this.session.kesimpulan_umum || "")) return;
    await AuditEtikaBatukService.update(this.session.id, {
      unit_id: this.session.unit_id,
      tanggal_audit: this.session.tanggal_audit,
      metode_audit: this.session.metode_audit,
      periode_bulan: this.session.periode_bulan,
      periode_tahun: this.session.periode_tahun,
      kesimpulan_umum: this.kesimpulanModel
    });
    this.session.kesimpulan_umum = this.kesimpulanModel;
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID");
  }

  bulanName(b: number): string {
    const names = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    return names[b] || "";
  }

  printPdf() {
    AuditEtikaBatukService.printPdf(this.session.id);
  }

  openSignDialog(stage: "auditor" | "ketua_ppi" | "kaunit" | "direktur") {
    this.signStage = stage;
    this.signPassword = "";
    this.signDialog = true;
  }

  async confirmSign() {
    if (!this.signStage) return;
    this.signing = true;
    try {
      const handlers: any = {
        auditor: AuditEtikaBatukService.submitAuditor,
        ketua_ppi: AuditEtikaBatukService.verifyKetuaPpi,
        kaunit: AuditEtikaBatukService.approveKaunit,
        direktur: AuditEtikaBatukService.approveDirektur
      };
      await handlers[this.signStage](this.session.id, { password: this.signPassword });
      this.signDialog = false;
      await this.loadSession();
    } finally {
      this.signing = false;
    }
  }

  openTemuan(t?: any) {
    this.temuanForm = t
      ? { ...t }
      : {
          uraian: "",
          kriteria_no: null,
          akar_masalah: "",
          rencana_tindak_lanjut: "",
          pic_nama: "",
          target_waktu: "",
          status: "open"
        };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    if (!this.temuanForm.uraian || !this.temuanForm.rencana_tindak_lanjut) return;
    this.savingTemuan = true;
    try {
      if (this.temuanForm.id) {
        await AuditEtikaBatukService.updateTemuan(this.session.id, this.temuanForm.id, this.temuanForm);
      } else {
        await AuditEtikaBatukService.storeTemuan(this.session.id, this.temuanForm);
      }
      this.temuanDialog = false;
      await this.loadSession();
    } finally {
      this.savingTemuan = false;
    }
  }

  async deleteTemuan(t: any) {
    if (!confirm(`Hapus temuan #${t.urutan}?`)) return;
    await AuditEtikaBatukService.destroyTemuan(this.session.id, t.id);
    await this.loadSession();
  }
}
